common.View.create('shop::Habitats.Website.Modules.ShopCheckout.Order.Signed', {

    ajaxCalls: [],

    onDOMLoad() {
        this.initFieldChange();
    },

    initFieldChange()
    {
        this.element
            .find('input[name="signed"]')
                .change((event) => {
                    // Abort ajax calls
                    this.abortAjaxCalls();
                    console.log('change');

                    // On delivery method change
                    this.initSignedFieldChange( $(event.currentTarget).val() );
                })
                .end();

    },

    async abortAjaxCalls()
    {
        // There are ajax calls running?
        if( this.ajaxCalls ) {
            // Abort all calls
            for(let i = 0; i < this.ajaxCalls.length; i++) {
                this.ajaxCalls[i].abort();
            }
        }
    },

    async initSignedFieldChange(value)
    {
        // Post
        let ajaxCallPromise = $.post(this.element.data('url') + '/set-signed', {
            signed: value
        });
        console.log( ajaxCallPromise );

        // Push to ajax calls
        this.ajaxCalls.push(ajaxCallPromise);

        // Wait for ajax call to finish
        await ajaxCallPromise;

        // Reload totals
        shop.Habitats.Website.Modules.ShopCheckout.Order.Index.getInstance(this).reloadTotals();
    },

});
